import * as client_hooks from '../../../src/hooks.client.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38')
];

export const server_loads = [0];

export const dictionary = {
		"/": [~2],
		"/about": [3],
		"/access": [~4],
		"/contact": [5],
		"/contact/thanks": [6],
		"/courses": [7],
		"/courses/ai3d": [8],
		"/courses/mat": [9],
		"/courses/movement-principles": [10],
		"/courses/reformer": [11],
		"/draft": [~12],
		"/entry": [~13],
		"/entry/thanks": [14],
		"/faq": [~15],
		"/faq/[category]": [~16],
		"/feedback": [17],
		"/followup": [18],
		"/goods-order": [~19],
		"/goods-order/thanks": [20],
		"/master-instructor": [~21],
		"/master-instructor/preview": [~22],
		"/news": [~23],
		"/news/preview": [~25],
		"/news/[slug]": [~24],
		"/otherschools": [~26],
		"/prices": [27],
		"/prices/set": [28],
		"/prices/single": [29],
		"/schedule": [~30],
		"/sentry-example": [31],
		"/sitemap": [~32],
		"/studios": [~33],
		"/studios/preview": [~35],
		"/studios/[slug]": [~34],
		"/terms": [~36],
		"/thanks": [37],
		"/tradelaw": [~38]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';